import MarkdownEditor from "./markdownEditor/MarkdownEditor";
import TranslationControls from "./TranslationControls";
import Exporter, {
  AppItemsExporter,
  ConsumersExporter,
  MembershipsExporter,
} from "./SimpleExporter";
import wrapProvider from "../../helpers/components/wrapProvider";
import store from "../../store";
import MemberManagerDropdown from "./MemberManagerDropDown";
import { RoleDirectoryPicker } from "./PermissionPicker";
import GroupMembershipRolePicker from "./GroupMembershipRolePicker";

export default {
  "shared/MarkdownEditor": MarkdownEditor,
  "shared/Exporter": Exporter,
  "shared/AppItemsExporter": AppItemsExporter,
  "shared/MembershipsExporter": MembershipsExporter,
  "shared/ConsumersExporter": ConsumersExporter,
  "shared/TranslationControls": wrapProvider(store)(TranslationControls),
  "shared/MemberManagerDropdown": MemberManagerDropdown,
  "shared/RoleDirectoryPicker": RoleDirectoryPicker,
  "shared/GroupMembershipRolePicker": GroupMembershipRolePicker,
};
